class SaleCountdown extends HTMLElement {
  constructor() {
    super();
    this.endTime = Date.parse(this.dataset.endDatetime);
    this.timerEl = this.querySelector('.sale-countdown__timer');
    this.endedEl = this.querySelector('.sale-countdown__ended');
    this.days = this.querySelector('[data-countdown-days]');
    this.hours = this.querySelector('[data-countdown-hours]');
    this.minutes = this.querySelector('[data-countdown-minutes]');
    this.seconds = this.querySelector('[data-countdown-seconds]');
  }

  connectedCallback() {
    if (isNaN(this.endTime)) return;
    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.timerEl.hidden = true;
      this.endedEl.hidden = false;
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.days.textContent = String(days).padStart(2, '0');
    this.hours.textContent = String(hours).padStart(2, '0');
    this.minutes.textContent = String(minutes).padStart(2, '0');
    this.seconds.textContent = String(seconds).padStart(2, '0');
  }
}

customElements.define('sale-countdown', SaleCountdown);
